angular.module('ui.order.stepDetailed', [])

    .directive('stepDetailed', function () {
        return {
            restrict: "E",
            templateUrl: 'app/ui/order/stepDetailedView/stepDetailed/stepDetailed.html',
            scope: {},
            controller: 'StepDetailedController',
            controllerAs: 'StepDetailedController'
        };
    })

    .controller('StepDetailedController', function ($window, $rootScope, $scope, $state, $q, $log, toastr, gettextCatalog, orderItemsGridSharedSettings,
                                                    gridDataProvider, stepDetailedControllerUpdatesService,
                                                    usersRepository, workflowRepository, $customisationConfig,
                                                    serverLocalization, uiLocalization, customResourceResolver) {

        var lastSelectedIndex;
        var lastPageNumber;

        $scope.specifiedItemNotFound = false;
        $scope.isDataLoaded = false;
        $scope.isOrderItemDataLoaded = false;
        $scope.hidemenu = ($state.params.hidemenu && $state.params.hidemenu === 'true');

        $scope.step = orderItemsGridSharedSettings.getStepFilter() || 'all-open';
        $scope.orderItemIdFromParams = $state.params.orderItemId;

        $scope.pageNumber = orderItemsGridSharedSettings.getPageNumber();
        if (!$scope.pageNumber) {
            $scope.pageNumber = 1;
            orderItemsGridSharedSettings.setPageNumber(1);
        }
        $scope.getRandom = function (start, stop) { return Math.floor(Math.random() * (stop - start)) + start; };

        _.extend($scope, {
            toFirstPage: toFirstPage,
            toPrevPage: toPrevPage,
            toNextPage: toNextPage,
            toLastPage: toLastPage,
            
            selectOrderItem: selectOrderItem,

            onOrderItemLoadStart: onOrderItemLoadStart,
            onOrderItemLoadEnd: onOrderItemLoadEnd,
            onOrderItemActionExecute: onOrderItemActionExecute,
            onOrderItemActionExecuteStart: onOrderItemActionExecuteStart,

            setShadows: setShadows,
            getGridViewUri: getGridViewUri
        });

        initController();

        function initController() {
            initStepHeader();
            reloadList();
            initWatchers();
        }

        function initWatchers() {

            stepDetailedControllerUpdatesService.onOrderItemChanged(function () {
                reloadList();
            });
            stepDetailedControllerUpdatesService.onOrderChanged(function () {
                reloadList();
            });
            stepDetailedControllerUpdatesService.onNewOrderItem(function () {
                reloadList();
            });

            angular.element(document.querySelector('#order-items-list-ul')).on('scroll',
                function(e) {
                    $scope.setShadows(e);
                });
            angular.element($window).on('resize',
                function(e) {
                    $scope.setShadows(e);
                });

            angular.element(document).keydown(function (e) {
                if (!$scope.isDataLoaded || !e || !e.keyCode || !e.target) {
                    return;
                }
                var elementName = e.target.nodeName.toLowerCase();
                if (elementName === 'input' || elementName === 'textarea') {
                    return; //ignore arrows when inside input boxes
                }
                switch(e.keyCode) {
                    case 37:
                        //Left
                        if ($scope.pageNumber > 1) {
                            toPrevPage();
                        }
                        break;
                    case 39:
                        //Right
                        if ($scope.pageNumber < $scope.totalPageCount) {
                            toNextPage();
                        }
                        break;
                    case 38:
                        //Up
                        if (lastSelectedIndex > 0) {
                            lastSelectedIndex--;
                            selectOrderItem($scope.orderItems[lastSelectedIndex]);

                        } else if ($scope.pageNumber > 1) {
                            lastSelectedIndex = orderItemsGridSharedSettings.getPageSize() - 1;
                            toPrevPage();
                        }
                        break;
                    case 40:
                        //Down
                        if (lastSelectedIndex < ($scope.orderItems.length - 1)) {
                            lastSelectedIndex++;
                            selectOrderItem($scope.orderItems[lastSelectedIndex]);

                        } else if($scope.pageNumber < $scope.totalPageCount) {
                            lastSelectedIndex = 0;
                            toNextPage();
                        }
                        break;
                    default:
                        //Do nothing
                        break;

                }

                return;
            });

            $scope.$on(
                "$destroy",
                function () {
                    stepDetailedControllerUpdatesService.onOrderItemChanged(null);
                    stepDetailedControllerUpdatesService.onNewOrderItem(null);
                    stepDetailedControllerUpdatesService.onOrderChanged(null);
                    angular.element(document).off('keydown');
                    angular.element(document.querySelector('#order-items-list-ul')).off('scroll');
                    angular.element($window).off('resize');
                }
            );
        }

        var isScrollingItemsList = false;
        function setShadows(event) {
            var itemsListContainer = angular.element(document.querySelector('.nav-menu.order-items-list'));
            var eventTarget = document.querySelector('#order-items-list-ul');
            if (!eventTarget && event) {
                eventTarget = event.target;
            }
            if (!eventTarget || eventTarget.id !== 'order-items-list-ul') {
                return;
            }
            
            if (!isScrollingItemsList) {
                window.requestAnimationFrame(function() {
                    try {
                        if (!eventTarget || eventTarget.children.length < 1) {
                            return;
                        }

                        var endOfScroll =
                            eventTarget.scrollHeight -
                                eventTarget.clientHeight -
                                2; //safer to subtract some more pixels

                        if (eventTarget.scrollTop > 0) {
                            itemsListContainer.addClass('off-top');
                        } else {
                            itemsListContainer.removeClass('off-top');
                        }
                        if (eventTarget.scrollTop < endOfScroll) {
                            itemsListContainer.addClass('off-bottom');
                        } else {
                            itemsListContainer.removeClass('off-bottom');
                        }
                        isScrollingItemsList = false;
                    } catch (e) {
                        //something happened during updating of the orderitems list classes to indicate its scrollability
                    }
                });
                isScrollingItemsList = true;
            }
        }

        /**
         * Select orderItem
         * @param {RepresentationModel} orderItem model
         */
        function selectOrderItem(orderItem) {
            $scope.orderItemId = orderItem ? orderItem.getId() : null;
            orderItemsGridSharedSettings.setSelectedOrderItemId($scope.orderItemId);

            var lastSelected = _.findIndex($scope.orderItems, function (rm) {
                return rm.getId() === $scope.orderItemId;
            });
            if (lastSelected < 0) {
                lastSelected = 0;
            }
            lastSelectedIndex = lastSelected;
            $scope.specifiedItemNotFound = false;

            updatePageTitle(orderItem);
        }

        function onOrderItemLoadStart() {
            $scope.isOrderItemDataLoaded = false;
        }

        function onOrderItemLoadEnd() {
            $scope.isOrderItemDataLoaded = true;
        }

        var isOrderItemActionExecuting = false;

        function onOrderItemActionExecuteStart() {
            isOrderItemActionExecuting = true;
        }

        function onOrderItemActionExecute() {
            isOrderItemActionExecuting = false;
            return reloadList();
        }

        function updatePageTitle(orderItem) {
            customResourceResolver
                .resolveConfig("order-item-card-page-title-getter", null, { orderItem: orderItem })
                .then(function (getPageTitle) {
                    var pageTitle = getPageTitle ? getPageTitle() : null;
                    $rootScope.pageTitle =  pageTitle || gettextCatalog.getString('OrderManager: Item ') + $scope.orderItemId;
                });
        }

        function getGridViewUri() {
            var customFilter = orderItemsGridSharedSettings.getCustomFilter();
            if (customFilter) {
                return customFilter.targetUri + '?filter=' + customFilter.name;
            } else {
                return '#/client/orders/' + $scope.step;
            }
        }

        /**
         * Reload order items list
         */
        function reloadList() {
            if (isOrderItemActionExecuting) {
                return;
            }
            $scope.isDataLoaded = false;
            orderItemsGridSharedSettings.setPageNumber($scope.pageNumber);
            lastPageNumber = $scope.pageNumber;
            orderItemsGridSharedSettings.setForceIgnorePageSize(angular.isDefined($scope.orderItemIdFromParams) && $scope.orderItemIdFromParams !== '');

            return gridDataProvider.getData()
                .then(function (searchResults) {
                    $scope.orderItems = searchResults.items;

                    $scope.$applyAsync(function() {
                        $scope.setShadows();
                    });

                    $scope.pageNumber = orderItemsGridSharedSettings.getPageNumber();
                    $scope.totalPageCount = searchResults.totalPageCount;

                    fixSelection(searchResults);
                    $scope.orderItemId = orderItemsGridSharedSettings.getSelectedOrderItemId();

                    $scope.isDataLoaded = true;

                    updatePageTitle($scope.orderItem);

                    if (searchResults.totalCount === 0 && searchResults.items.length === 0) {
                        // todo sound notification
                        if (orderItemsGridSharedSettings.isClear()) {
                            toastr.info(gettextCatalog.getString("Going back to the home screen..."), gettextCatalog.getString("No order items to display at current step"));
                            orderItemsGridSharedSettings.clear();
                            $state.go('client.home', {
                                step: $scope.step
                            });
                        } else {
                            toastr.info(gettextCatalog.getString("Going back to the grid..."), gettextCatalog.getString("No order items to display"));
                            orderItemsGridSharedSettings.clear();
                            $state.go('client.orders', {
                                step: $scope.step
                            });
                        }
                    }
                }, function (err) {
                    $scope.isDataLoaded = true;
                    $log.error("Can't load data for list in stepDetailed view. Cause: %s", err.message);
                    toastr.error(err.message, gettextCatalog.getString("Can't load list of order items"));
                });
        }

        function fixSelection(resp) {
            if (resp.items.length > 0) {
                var selectedId = orderItemsGridSharedSettings.getSelectedOrderItemId();

                if (selectedId) {
                    var lastSelected = _.findIndex(resp.items, function (rm) {
                        return rm.getId() === selectedId;
                    });
                    if (lastSelected >= 0) {
                        lastSelectedIndex = lastSelected;
                    } else {
                        //item was moved or deleted, so last selected item id not found in the new search result
                        if ((lastPageNumber && lastPageNumber !== orderItemsGridSharedSettings.getPageNumber()) ||
                            lastSelectedIndex >= resp.items.length) {
                            lastSelectedIndex = resp.items.length - 1;
                        } else if (!lastSelectedIndex || lastSelectedIndex === -1) {
                            //just select first on the page
                            lastSelectedIndex = 0;
                        } else {
                            //otherwise we keep last selected index so the next item in the list will get selected
                            //when we moved further in the workflow chain the item we stayed on
                        }
                    }
                    $scope.orderItem = resp.items[lastSelectedIndex];
                }
                if (lastSelectedIndex == null || lastSelectedIndex < 0) {

                    //If we don't have order Item Id supplied from external source via url param
                    //and we had no information on last selected Id, then just select first one in the collection
                    if (!$scope.orderItemIdFromParams) {
                        lastSelectedIndex = 0;

                        if (lastSelectedIndex >= resp.items.length) {
                            lastSelectedIndex = resp.items.length - 1;
                        }

                        orderItemsGridSharedSettings.setSelectedOrderItemId(resp.items[lastSelectedIndex].getId());
                        $scope.orderItem = resp.items[lastSelectedIndex];
                    } else {
                        //if we have order Item Id supplied externally via url param but it wasn't found in the collection 
                        //selected index -1 or null (not found) - don't select anything
                        lastSelectedIndex = null;
                        orderItemsGridSharedSettings.setSelectedOrderItemId(null);
                        $scope.orderItem = null;
                        $scope.specifiedItemNotFound = true;
                    }
                } else {
                    $scope.specifiedItemNotFound = false;
                    orderItemsGridSharedSettings.setSelectedOrderItemId(resp.items[lastSelectedIndex].getId());
                }
            } else {
                lastSelectedIndex = null;
                orderItemsGridSharedSettings.setSelectedOrderItemId(null);
                $scope.orderItem = null;
            }
        }

        /**
         * Method to collect/construct data necessary to render corresponding step icon/button in the header of the nav bar
         * @returns {Promise}
         */
        function initStepHeader() {
            $scope.stateDisplayName = "";
            $scope.stateIconName = "";

            return $q.all(
                [
                    usersRepository.getCurrentUser(),
                    workflowRepository.getSteps(),
                    customResourceResolver.resolveWorkflow()
                ]
            ).then(function (data) {
                var workflowConfig = data[2];
                var stepDisplayName = "All Items";

                var isCustomer = data[0].isCustomer();
                var step = _.find(data[1], function (s) {
                    return s.$model.code === $scope.step;
                });
                var stepConfig = _.find(workflowConfig.steps, function (s) {
                    return s.code === $scope.step;
                });

                if (step) {
                    stepDisplayName = isCustomer ? step.$model.publicNameResource : step.$model.nameResource;
                }

                var fallbackIconForStep = function (stepCode) {
                    if (stepCode === "all-open") {
                        return "track";
                    }
                    return $customisationConfig.hasResource(function (res) { return _.string.contains(res, stepCode + "."); }) ? stepCode : "workflow";
                };
                
                if ($scope.step && $scope.step !== "all-open") {
                    $scope.stateDisplayName = serverLocalization.translate(stepDisplayName);
                    $scope.stateIconName = angular.isUndefined(stepConfig) ? fallbackIconForStep($scope.step) :
                        (angular.isDefined(stepConfig.publicImageResourceName) && isCustomer
                            ? stepConfig.publicImageResourceName
                            :
                            (angular.isDefined(stepConfig.imageResourceName) ? stepConfig.imageResourceName :
                                fallbackIconForStep($scope.step)));
                } else {
                    //See if we have custom filter applied
                    var customFilter = orderItemsGridSharedSettings.getCustomFilter();
                    if (customFilter) {
                        $scope.stateDisplayName = gettextCatalog.getString(customFilter.name || "Filtered Items");
                        $scope.stateIconName = customFilter.iconName || fallbackIconForStep($scope.step);
                    } else {
                        $scope.stateDisplayName = gettextCatalog.getString("All Items");
                        $scope.stateIconName = fallbackIconForStep($scope.step);
                    }
                }
            });
        }

        function toFirstPage() {
            if (!$scope.isDataLoaded) {
                return;
            }
            $scope.pageNumber = 1;
            reloadList();
        }

        function toPrevPage() {
            if (!$scope.isDataLoaded) {
                return;
            }
            $scope.pageNumber = $scope.pageNumber - 1;
            if ($scope.pageNumber <= 0 || $scope.pageNumber > $scope.totalPageCount) {
                $scope.pageNumber = 1;
            }
            reloadList();
        }

        function toNextPage() {
            if (!$scope.isDataLoaded) {
                return;
            }
            $scope.pageNumber = $scope.pageNumber + 1;
            if ($scope.pageNumber <= 0 || $scope.pageNumber > $scope.totalPageCount) {
                $scope.pageNumber = $scope.totalPageCount;
            }
            reloadList();
        }

        function toLastPage() {
            if (!$scope.isDataLoaded) {
                return;
            }
            $scope.pageNumber = $scope.totalPageCount;
            reloadList();
        }
    })

    // Separate service for update events (to prevent multiple event subscription)
    .service('stepDetailedControllerUpdatesService', function (rest) {
        var _this = this;
        var newOrderItemCb;
        var orderItemChangedCb;
        var orderChangedCb;

        rest.events.on("modelCreatedOnServer", function (modelInfo) {
            if (!newOrderItemCb) {
                return;
            }
            if (modelInfo && modelInfo.modelType === "OrderItemModel") {
                newOrderItemCb(modelInfo);
            }
        });

        rest.events.on("modelUpdatedOnServer", function (modelInfo) {
            if (modelInfo.modelType === "OrderItemModel" && orderItemChangedCb) {
                orderItemChangedCb(modelInfo);
            } else if (modelInfo.modelType === "OrderModel" && orderChangedCb) {
                orderChangedCb(modelInfo);
            }
        });

        _this.onNewOrderItem = function (cb) {
            newOrderItemCb = cb;
        };

        _this.onOrderItemChanged = function (cb) {
            orderItemChangedCb = cb;
        };

        _this.onOrderChanged = function (cb) {
            orderChangedCb = cb;
        };

        return _this;
    })

;
